import {
  DeviceCalibration,
  PatchDeviceBody,
} from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export interface PatchDeviceParams extends PatchDeviceBody {
  deviceId: number;
}

/** Replace a device's perspective transform; returns the device as now stored. */
export const patchDevice = async ({
  deviceId,
  ...body
}: PatchDeviceParams): Promise<DeviceCalibration> => {
  const { data } = await queryBuilder(
    'PATCH',
    `devices/${deviceId}`,
    undefined,
    body
  );
  return data;
};
